module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Foamcore.a1f33f74.jpg";